
<div #dock class="toast-dock from-{{ top_or_bottom }} from-{{ center_left_or_right }}"></div>